"use client"

import React, { useState } from 'react'
import DashboardContentWrapper from '@/shared/components/dashboard-content-wrapper'
import Heading from '@/shared/components/ui/typography/heading'
import PartnersList from '@/features/partners/components/partners-list'
import { Button } from '@/shared/components/ui/button'
import { Plus } from 'lucide-react'
import { useRouter } from 'next/navigation'
import { useRegionId } from '@/shared/hooks/use-region-id'
import { buildRegionAwareHref } from '@/shared/lib/utils/region-url.utils'
import LocationSelector from '@/shared/components/location-selector'
import PartnersSearch from '@/features/partners/components/partners-search'
import { useSession } from '@/features/auth/context/session.context'
import { UserRole } from '@/shared/constants/user-roles'
import ScrollToTopFab from '@/shared/components/scroll-to-top-fab'

export default function RegionPartnersPage() {
  const router = useRouter()
  const { regionSlug, region, regionId } = useRegionId()
  const { session } = useSession()
  const [selectedRegionId, setSelectedRegionId] = useState<string | null>(null)
  
  // Only ADMIN and BASE_LEADER can add partners
  const canManagePartners = session?.role === UserRole.ADMIN || session?.role === UserRole.BASE_LEADER

  const handleAddPartner = () => {
    const href = buildRegionAwareHref(regionSlug, '/partners/create')
    router.push(href)
  }

  return (
    <DashboardContentWrapper className="flex flex-col gap-7 pb-24 md:pb-5">
      <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-start">
        <div>
          <Heading>Partners</Heading>
        </div>
        <LocationSelector onLocationChange={setSelectedRegionId} />
      </div>
      
      <div className="border rounded px-3 py-5 space-y-4 mb-10">
        <div className='flex flex-col gap-4'>
          {/* Desktop: search (center), Add Partner (right) */}
          {/* Mobile: search and Add Partner on same row */}
          <div className='flex flex-col lg:grid lg:grid-cols-[1fr_auto] gap-4 items-center'>
            {/* Search and Add Partner on same row for mobile */}
            <div className="flex items-center gap-2 w-full lg:justify-center lg:min-w-0">
              <div className="flex-1 w-full">
                <PartnersSearch />
              </div>
              {canManagePartners && (
                <Button 
                  onClick={handleAddPartner} 
                  className="bg-primary hover:bg-primary/90 text-white font-bold rounded-md gap-2 py-1 h-10 flex items-center flex-shrink-0"
                >
                  <Plus className="w-5 h-5" />
                  <span className="hidden sm:inline">Add Partner</span>
                </Button>
              )}
            </div>
          </div>
        </div>
        <PartnersList />
      </div>
      <ScrollToTopFab />
    </DashboardContentWrapper>
  )
}
